
<div class="login-container" [dir]="direction()">

  <!-- Background Decoration -->
  <div class="background-glow glow-one"></div>
  <div class="background-glow glow-two"></div>


  <mat-card class="login-card">

    <!-- Loading -->
    <mat-progress-bar
      mode="indeterminate"
      *ngIf="isLoading()"
      class="login-progress">
    </mat-progress-bar>


    <!-- Brand -->
    <div class="brand">

      <div class="brand-icon">
       
<img src="assets/images/logoo.png" alt="Logo" />

      
      </div>

     <!--  <span class="brand-name">
        AVERA
      </span> -->

      <span class="admin-label">
        {{ 'login.adminPortal' | translate }}
      </span>

    </div>


   


    <!-- Form -->
    <mat-card-content>

      <form
        [formGroup]="loginForm"
        (ngSubmit)="onSubmit()"
      >

        <!-- Email -->
        <mat-form-field
          appearance="outline"
          class="full-width"
        >

          <mat-label>
            {{ 'login.email' | translate }}
          </mat-label>

          <mat-icon matPrefix>
            email
          </mat-icon>

          <input
            matInput
            type="email"
            formControlName="email"
            placeholder="admin@example.com"
          />

          <mat-error
            *ngIf="
              loginForm.get('email')?.hasError('required')
            "
          >
            {{ 'login.emailRequired' | translate }}
          </mat-error>

          <mat-error
            *ngIf="
              loginForm.get('email')?.hasError('email')
            "
          >
            {{ 'login.invalidEmail' | translate }}
          </mat-error>

        </mat-form-field>


        <!-- Password -->
        <mat-form-field
          appearance="outline"
          class="full-width"
        >

          <mat-label>
            {{ 'login.password' | translate }}
          </mat-label>

          <mat-icon matPrefix>
            lock
          </mat-icon>

          <input
            matInput
            [type]="hidePassword ? 'password' : 'text'"
            formControlName="password"
          />

          <button
            mat-icon-button
            matSuffix
            type="button"
            (click)="hidePassword = !hidePassword"
            class="password-toggle"
            [attr.aria-label]="(hidePassword ? 'users.showPassword' : 'users.hidePassword') | translate"
          >

            <mat-icon>
              {{ hidePassword ? 'visibility_off' : 'visibility' }}
            </mat-icon>

          </button>

          <mat-error
            *ngIf="
              loginForm.get('password')?.hasError('required')
            "
          >
            {{ 'login.passwordRequired' | translate }}
          </mat-error>

        </mat-form-field>


        <!-- Error -->
        <div
          class="error-container"
          *ngIf="errorMessage()"
        >

          <mat-icon>
            error_outline
          </mat-icon>

          <span>
            {{ errorMessage()! | translate }}
          </span>

        </div>


        <!-- Login -->
        <button
          mat-raised-button
          type="submit"
          class="login-button"
          [disabled]="
            loginForm.invalid || isLoading()
          "
        >

          <mat-icon *ngIf="!isLoading()">
            login
          </mat-icon>

          <span>
            {{ (isLoading() ? 'login.signingIn' : 'login.signIn') | translate }}
          </span>

        </button>

      </form>

    </mat-card-content>


    <!-- Footer -->
    <div class="login-footer">
      <span>✦</span>
      <span>{{ 'login.secureAccess' | translate }}</span>
      <span>✦</span>
    </div>

  </mat-card>

</div>